// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11LxQ","colBig":"styles_colBig__3-Unh","colSmall":"styles_colSmall__gO7ar"};